var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronRightDoubleSvg from './chevron-right-double.icon.svg';
export const ChevronRightDoubleIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronRightDoubleSvg });
};
_react_refresh_temp_1 = ChevronRightDoubleIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronRightDoubleIcon");
